import React from 'react';

/**
 * Sağ alt köşede sabit duran iletişim butonları
 * WhatsApp, Telefon, Konum
 */
const FloatingButtons: React.FC = () => {
  return (
    <div className="fab-stack">
      <a
        className="fab-btn fab-whatsapp"
        href="https://wa.me/905550857971"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp ile yaz"
        title="WhatsApp"
      >
        <i className="bi bi-whatsapp"></i>
      </a>
      <a
        className="fab-btn fab-phone"
        href="tel:+905550857971"
        aria-label="Telefon et"
        title="Telefon"
      >
        <i className="bi bi-telephone-fill"></i>
      </a>
      <a
        className="fab-btn fab-location"
        href="https://www.google.com/maps/place/Sinan+Karada%C5%9F+Hukuk+B%C3%BCrosu/@36.710249,37.1296615,18z/data=!3m1!4b1!4m6!3m5!1s0x152fd19b5c8a0921:0xcabe5b285829e577!8m2!3d36.710249!4d37.130427!16s%2Fg%2F11vm1v0cp1?entry=ttu&g_ep=EgoyMDI2MDMyMi4wIKXMDSoASAFQAw%3D%3D"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Konumu aç"
        title="Sinan Karadaş Hukuk Bürosu"
      >
        <i className="bi bi-geo-alt-fill"></i>
      </a>
    </div>
  );
};

export default FloatingButtons;
